export const tradingViewChartIntervals = ['10S', '30S', '1', '5', '10', '30', '1D', '1W', '1M', '1Y'];
export var TableClass;
(function (TableClass) {
    TableClass["platforms"] = "platforms";
    TableClass["joinedAccounts"] = "joinedAccounts";
    TableClass["accounts"] = "accounts";
    TableClass["symbols"] = "symbols";
    TableClass["traders"] = "traders";
    TableClass["positions"] = "positions";
    TableClass["joinedPositions"] = "joinedPositions";
    TableClass["missingPositions"] = "missingPositions";
    TableClass["fills"] = "fills";
    TableClass["orders"] = "orders";
})(TableClass || (TableClass = {}));
//# sourceMappingURL=workspace.js.map